import { FighterOrderDto } from "../../../model/Dto/FighterOrderDto";
import { ApiRequest, RequestMethod } from "../../request";

export type SaveOrderRequest = {
  teamId: string;
  fighters: FighterOrderDto[];
};

export async function SaveOrder(
  request: SaveOrderRequest): Promise<boolean> {
  const URL = `/api/team/${request.teamId}/order`;

  const apiRequest = new ApiRequest();

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody(request);

  const response: any = await apiRequest.send();

  return response.status === 200;
}
